import { Box, Flex, Text } from '@mantine/core'
import ActionMenu from '@v2/commons/components/ActionMenu/ActionMenu.component'
import { openAddProviderLocationClinicModal } from '@v2/domains/membership/components/CreateProviderLocationClinicModal/CreateProviderLocationClinicModal.component'

import { Icons } from 'src/common/components'

import { ProviderDto } from '../../clinics.type'
import ClinicDoctorsTable from '../ClinicDoctorTable/ClinicDoctorsTable.component'
import classes from './clinic-doctors.module.scss'

interface ClinicLocationsProps {
  providers: ProviderDto[]
  clinicId: string
  clinicName: string
}

const ClinicDoctors = ({
  providers,
  clinicId,
  clinicName,
}: ClinicLocationsProps) => {
  return (
    <Box my="md">
      <Flex
        justify="space-between"
        align="flex-start"
        className={classes.headerWrapper}
        mb="xl"
      >
        <Text fw={700} c="blue.5">
          Provider Information
        </Text>
        <ActionMenu
          menuItems={[
            {
              label: 'Add New Provider',
              color: 'blue',
              icon: <Icons.Plus />,
              onClick: () =>
                openAddProviderLocationClinicModal(clinicId, clinicName),
              enable: true,
            },
          ]}
        />
      </Flex>
      <ClinicDoctorsTable
        providers={providers}
        clinicId={clinicId}
        clinicName={clinicName}
      />
    </Box>
  )
}

export default ClinicDoctors
